import { useNavigate } from "react-router-dom";
import styles from "../assets/css/Header.module.css";

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <header className={styles.header}>
      <div className={styles.logo}>LadyTaxi</div>
      <div className={styles.box1}>
        <div onClick={handleLogout} className={styles.text}>
          Выйти
        </div>
        <div className={styles.square}>
          <img
            onClick={handleLogout}
            className={styles.exiticon}
            src="/images/bell.svg"
            alt="exit icon"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
